export const locale = {
    lang: 'fr',
    data: {
        "Acc_Lbl_BasicInformation" : "Informations de base",
        "Acc_Lbl_FirstName" : "Prénom",
        "Acc_Lbl_LastName" : "Nom de famille",
        "Acc_Val_FirstNameReq" : "Le prénom est obligatoire.",
        "Acc_Val_LastNameReq" : "Le nom de famille est obligatoire.",
        "Acc_Val_Email" : "L'adresse de courriel doit être une adresse de courriel valide.",
        "Acc_Placeholder_Email" : "you@yourdomain.com",
        "Acc_Placeholder_Name" : "par exemple",
        "Acc_Lbl_Work Email" : "Courriel de travail",
        "Acc_Head_Ph.No" : "Numéros de téléphone",
        "Acc_War_Ph.No" : "Vous n'avez aucun numéro de téléphone associé à ce compte. Veuillez considérer d'en ajouter un.",
        "Acc_Val_Ph.No" : "Le numéro de téléphone doit être un numéro de téléphone valide.",
        "Acc_War_NotVerified" : "Non vérifié",
        "Acc_War_Verified" : "Vérifié",
        "Acc_War_InProgress": "En cours",
        "Acc_Btn_VeriyByText": "Vérifier par texte",
        "Acc_Btn_VeriyByCall": "Vérifier par appel",
        "Acc_War_StopRecieved" : "Commande d'arrêt reçue",
        "Acc_Hover_NotVerified" : "Non vérifié : vous devez vérifier votre numéro par SMS ou par appel avant que ce numéro puisse être utilisé pour recevoir des notifications.",
        "Acc_Btn_AddPh.No" : "Ajouter un numéro de téléphone",
        "Mobile" : "Mobile",
        "Work" : "Travail",
        "Home" : "Domicile",
        "Acc_Error_Verification" : "Un problème est survenu lors de la récupération des paramètres de votre compte.",
        "Acc_Not_Ph.NoSMS" : "Une demande de vérification de votre numéro de téléphone a été envoyée sous forme de SMS.",
        "Acc_Not_Ph.NoCall" : "Une demande de vérification de votre numéro de téléphone a été envoyée sous forme d'appel téléphonique.",
        "Acc_Error_Ph.NoSMS" : "Impossible d'initier le SMS de vérification.",
        "Acc_Error_Ph.NoCall" : "Impossible de lancer l'appel téléphonique de vérification.",
        "Acc_Success_Ph.No" : "Demande de vérification envoyée",
        "Acc_Verification_InProgress" : "En cours : la vérification a été envoyée par appel téléphonique ou par SMS et le système attend la réponse.",
        "Acc_Verification_Verified" : "Vérifié : vous pouvez désormais activer les SMS et recevoir des notifications sur ce numéro.",
        "Acc_STOPMessage" : "Commande d'arrêt reçue : le destinataire de la notification a répondu avec un message STOP; par conséquent, le téléphone reste non vérifié.",
        "Acc_Verification_NotVerified" : "Non vérifié : vous devez vérifier votre numéro par SMS ou par appel avant que ce numéro puisse être utilisé pour recevoir des notifications.",
        "Acc_Success_Message" : "Les paramètres de votre compte ont été enregistrés.",
        "Acc_Error_Save" : "Un problème est survenu lors de l'enregistrement des paramètres de votre compte.",
        "Acc_Language" : "Langue",
        "Secure_MFA_Header" : "Authentification multifacteurs (MFA)",
        "Secure_MFA_Description" : "MFA empêche l'accès non autorisé à votre compte en vous demandant de saisir un code de vérification lorsque cela vous est demandé",
        "Secure_MFA_Enable" : "MFA activé",
        "Secure_MFA_Disable" : "MFA désactivé",
        "Secure_Choose_MFA_Method" : "Choisissez votre méthode préférée de MFA :",
        "Secure_Authentication_App_Lbl" : "Application d'authentification (la plus sécurisée, recommandée)",
        "Secure_Phn_Verification_lbl" : "Vérification par téléphone",
        "Secure_Email_Verification_lbl" : "Vérification par courriel",
        "Secure_Single_Sign_lbl" : "Authentification unique (SSO)",
        "Secure_Enable_Single_Sign_lbl" : "Vous pouvez activer l'authentification unique en utilisant le compte de votre entreprise.",
        "Secure_lbl_Enable" : "Activer",
        "Secure_Single_Sign_Enabled_lbl" : "L'authentification unique a été activée pour ce compte avec l'adresse de courriel suivante :",
        "Secure_lbl_Disable" : "Désactiver",
        "Secure_Single_Sign_Error_lbl" : "Une erreur s'est produite lors de votre demande d'authentification unique. Veuillez réessayer ou contacter l'administrateur de votre entreprise.",
        "Secure_Automatic_Signout_Header" : "Déconnexion automatique",
        "Secure_Automatic_Signout_Description" : "Déconnectez-moi automatiquement lorsque j'ai été inactif pendant :",
        "Secure_Hour_lbl" : "heure",
        "Secure_Minute_lbl" : "Minute",
        "Secure_Timedout_Description" : "Paycor recommande une déconnexion automatique après 20 minutes; ce paramètre ne s'applique pas à Paycor Payroll. Ce paramètre prendra effet la prochaine fois que vous vous connecterez.",
        "Action_Lbl_MyAction" : "Mes actions",
        "Action_Not_SSOProvider" : "Vos informations d'identification sont gérées via votre fournisseur d'authentification unique (SSO).",
        "Action_Lnk_ChangePass" : "Changez votre mot de passe",
        "Action_Lnk_ChangeQue" : "Modifiez vos questions de Security",
        "Action_Lnk_ChangeUsername" : "Changer d'autres noms d'utilisateur pour une expérience d'authentification unique",
        "Action_Lnk_DeveloperPortal": "Go Back",
        "Notification_Setting_Display_Message" : "Veuillez sélectionner la manière dont vous souhaitez recevoir chaque notification individuelle.",
        "Notification_Text" : "Notifications",
        "Block_MySettings":"This page is not supported during Impersonation.",
        "Google_Auth_QR_Description1" : "Visitez la boutique d'applications de votre appareil mobile, recherchez « authentificateur » et téléchargez une application de votre choix. (Google Authenticator, Microsoft Authenticator et Authy sont populaires et faciles à utiliser)",
        "Google_Auth_QR_Description2" : "Utilisez l'application pour scanner ce code QR, qui synchronisera les codes qu'elle fournit avec votre compte Perform :",
        "Google_Auth_QR_Scan_Trouble_Linklbl" : "Vous avez du mal à scanner?",
        "Google_Auth_Code_Description" : "Avez-vous du mal à scanner le code-barres? Vous pouvez entrer cette clé avec votre adresse courriel dans votre application d'authentification sur votre appareil.",
        "Google_Auth_Code_Step1" : "Saisissez votre adresse de courriel et le code suivant dans votre application d'authentification.",
        "Google_Auth_Code_Step2" : "Appuyez sur continuer et confirmez le code à 6 chiffres généré à partir de votre appareil.",
        "Google_Auth_QR_Scan_Linklbl" : "Essayez de rescanner le code QR",
        "Google_Auth_Verify_Code_Description1" : "Vous recevrez un code à 6 chiffres lorsque votre compte aura été associé avec succès. Entrez ce code ci-dessous pour terminer la configuration de l'authentification Google.",
        "Google_Auth_Verify_Code_Description2" : "La prochaine fois que vous vous connecterez, vous serez invité à saisir un code.",
        "Google_Auth_Verify_Code_lbl" : "Code d'authentification à 6 chiffres",
        "Google_Auth_Verify_Code_Placeholder" : "Entrez le code",
        "Google_Auth_Invalid_Code_Error" : "Code d'authentification invalide",
        "Google_Auth_Setup_Header" : "Configurer l'authentificateur",
        "Google_Auth_QR_Retrieve_Error_Msg" : "Une erreur s'est produite lors de la récupération du code QR.",
        "Google_Auth_Code_Validating_Error_Msg" : "Une erreur s'est produite lors de la validation du code.",
        "Google_Auth_Code_Validating_Header" : "Confirmer le code de l'authentificateur",
        "Secure_MFA_Atleast_Two_Options_Select_Error" : "Au moins deux options MFA doivent être sélectionnées",
        "Secure_MFA_Data_Retrieving_Error" : "Un problème est survenu lors de la récupération de vos paramètres de Security MFA.",
        "Secure_MFA_Data_Saved_Msg" : "Vos paramètres MFA ont été enregistrés.",
        "Secure_MFA_Data_Save_Error_Msg" : "Un problème est survenu lors de l'enregistrement de vos paramètres MFA.",
        "Secure_SecureSetting_Data_Retrieving_Error" : "Un problème est survenu lors de la récupération de vos paramètres de Security.",
        "Secure_SecureSetting_Data_Saved_Msg" : "Vos paramètres de Security ont été enregistrés.",
        "Secure_SecureSetting_Data_Save_Error_Msg" : "Un problème est survenu lors de l'enregistrement de vos paramètres de Security.",
        "Notification_TextSMS" : "Texte (SMS)",
        "Notification_MobileApp" : "Application mobile",
        "Notification_Inapp" : "Dans l'application",
        "Notification_Email" : "Courriel :",
        "Notification_Save_Message" : "Préférences de notification enregistrées.",
        "Notification_Success" : "Succès!",
        "Notification_Error_Message" : "Un problème est survenu lors de l'enregistrement de vos préférences de notification.",
        "Notification_Error" : "Erreur!",

        // common  key value pairs that can be used in all pages can add inside this
        "Common" : {
          "Save" : "Sauvez",
          "Cancel" : "Annuler",
          "Error" : "Une erreur s'est produite.",
          "PleaseWait" : "Veuillez patienter...",
          "ErrorSummary" : "Erreur!",
          "Success" : "Succès",
          "Continue" : "Continuer",
          "Verify" : "Vérifier"
        },
        // End
        // title key value pair can be added
        "Title" : {
          "MySettings" : "Mes paramètres",
          "Account" : "Compte",
          "Security" : "Security",
          "Notification_Preferences" : "Préférences de notification"
        }
        // End
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/my-settings/shared/assets/i18n/fr.ts